import React, { Component } from "react";
import { Select } from "semantic-ui-react";
import Offer from "../../models/Offer";

class OfferSearchSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offers: [],
            term: "",
            existingdOffers: [],
            searchTimer: null,
        };

        this.additionalQueryParams = {};
        if (this.props.active === true) {
            this.additionalQueryParams.active = true;
        }
    }

    async componentDidMount() {
        if ((this.props.value ?? null) === null) return;
        const include = Array.isArray(this.props.value)
            ? this.props.value
            : [this.props.value];
        if (include.length === 0) return;
        const offers = await Offer.list({
            include,
        });
        this.setState({ existingdOffers: offers, offers });
    }

    async getdOffers() {
        const { term } = this.state;
        let exclude = this.props.value;
        if (Array.isArray(exclude) === false) {
            exclude = [exclude];
        }

        return Offer.list(
            Object.assign({ term, exclude }, this.additionalQueryParams)
        );
    }

    onChangeSearch(value) {
        this.setState({ term: value });

        if (this.isLoading) {
            clearTimeout(this.state.searchTimer);
        }

        if (value.length === 0) {
            return this.setState({ searchTimer: null });
        }

        const searchTimer = setTimeout(async () => {
            const offers = await this.getdOffers();
            clearTimeout(this.state.searchTimer);
            return this.setState({
                searchTimer: null,
                offers: offers.concat(this.state.existingdOffers),
            });
        }, 1000);

        this.setState({ searchTimer });
    }

    emptyListMessage() {
        if (this.isLoading) {
            return "Searching...";
        }

        if (this.state.term.length === 0) {
            return "Type to search for offers";
        }

        return "No offers found";
    }

    onChange(value) {
        const compareValue = Array.isArray(value) ? value : [value];
        const newExisting = [];
        for (const id of compareValue) {
            const existing = newExisting.some(({ _id }) => _id === id);
            if (existing === false) {
                const add =
                    this.state.offers.find(({ _id }) => _id === id) ?? null;
                newExisting.push(add);
            }
        }

        this.setState({
            term: "",
            existingdOffers: newExisting,
            offers: newExisting,
        });
        this.props.onChange(value);
    }

    get isLoading() {
        return this.state.searchTimer !== null;
    }

    dropdownOptions() {
        const options = this.state.offers.map((club, i) => ({
            key: i,
            text: `${club.name}`,
            value: club._id,
        }));

        return options;
    }

    render() {
        return (
            <Select
                placeholder={this.props.placeholder ?? "Search for offers..."}
                icon="search"
                selection
                loading={this.isLoading}
                value={this.props.value}
                onSearchChange={({ target }) =>
                    this.onChangeSearch(target.value)
                }
                onChange={(_, props) => this.onChange(props.value)}
                search
                multiple={this.props.multiple}
                options={this.dropdownOptions()}
                noResultsMessage={this.emptyListMessage()}
                disabled={this.props.disabled ?? false}
                fluid={this.props.fluid ?? false}
                className={"pr-2 " + this.props.className ?? ""}
            />
        );
    }
}

export default OfferSearchSelect;
